import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import useResizeObserver from '@react-hook/resize-observer';
import { useRef, useState } from 'react';
import { css, styled } from 'styled-components';
import { Box } from "../../box/src";
import { Dotdotdot } from "../../dotdotdot/src";
import { INFORMATION_TOOLTIP_SIZES, InformationTooltip, } from "../../information-tooltip/src";
import { POSITIONS } from "../../tooltip/src";
import { Required } from './Required';
export const LABEL_POSITIONS = ['top', 'right', 'left'];
export const Label = ({ children, disabled = false, fontWeight, id, multiline = true, noHtmlFor = false, position = 'top', required = false, tooltip, tooltipPosition = POSITIONS.TOP, wrapperProps = {}, }) => {
    const ref = useRef(null);
    const [isTruncated, setIsTruncated] = useState(false);
    useResizeObserver(ref, (entry) => {
        const e = entry.target.firstElementChild;
        if (!(e instanceof HTMLElement)) {
            return;
        }
        const truncated = e.offsetHeight < e.scrollHeight - 1 || e.offsetWidth < e.scrollWidth;
        setIsTruncated(truncated);
    });
    return (_jsxs(LabelWrapper, Object.assign({ "$position": position }, wrapperProps, { children: [_jsx(StyledLabel, Object.assign({ "$disabled": disabled, "$fontWeight": fontWeight, "$isMultiline": multiline }, (noHtmlFor ? null : { htmlFor: id }), { "data-testid": "ds-label" }, (isTruncated && typeof children === 'string'
                ? { title: children }
                : null), { children: multiline ? (_jsxs(_Fragment, { children: [children, required && _jsx(Required, {})] })) : (_jsxs(Box, { ref: ref, children: [_jsx(Dotdotdot, { clamp: 1, children: children }), required && _jsx(Required, {})] })) })), tooltip && (_jsx(Box, { lineHeight: "1px", ml: 2, children: _jsx(InformationTooltip, { inline: true, position: tooltipPosition, size: INFORMATION_TOOLTIP_SIZES.NORMAL, children: typeof tooltip === 'function' ? tooltip() : tooltip }) }))] })));
};
const StyledLabel = styled.label `
  ${({ $disabled, $fontWeight, $isMultiline, theme }) => css `
    display: block;
    color: ${theme.label.color};
    cursor: ${theme.label.cursor};
    font-size: ${theme.label.fontSize};
    font-weight: ${$fontWeight || theme.label.fontWeight};
    padding-bottom: 0 !important;
    user-select: none;
    ${$disabled && `pointer-events: none;`};
    ${$isMultiline && `align-items: flex-end;`};
    opacity: ${$disabled ? theme.input.disabled.opacity : 1};
    word-break: break-word;
  `}
`;
const LabelWrapper = styled(Box).attrs(({ $position, theme }) => (Object.assign(Object.assign(Object.assign({}, ($position === 'top' && { mb: theme.label.marginToInput })), ($position === 'right' && {
    alignItems: 'center',
    ml: theme.label.marginToInput,
})), ($position === 'left' && {
    alignItems: 'center',
    mr: theme.label.marginToInput,
})))) ``;
//# sourceMappingURL=Label.js.map